/**
 * MIRA Card Component
 * Wraps Shadcn Card with MIRA design system styles
 */

import React from 'react';
import {
  Card as ShadcnCard,
  CardHeader as ShadcnCardHeader,
  CardFooter as ShadcnCardFooter,
  CardTitle as ShadcnCardTitle,
  CardDescription as ShadcnCardDescription,
  CardContent as ShadcnCardContent,
} from '@/components/ui/card';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/layout/card.module.css';

export const Card = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnCard
        ref={ref}
        className={cn(styles.miraCard, className)}
        {...props}
      />
    );
  }
);

Card.displayName = 'MiraCard';

export const CardHeader = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnCardHeader
        ref={ref}
        className={cn(styles.miraCardHeader, className)}
        {...props}
      />
    );
  }
);

CardHeader.displayName = 'MiraCardHeader';

export const CardTitle = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnCardTitle
        ref={ref}
        className={cn(styles.miraCardTitle, className)}
        {...props}
      />
    );
  }
);

CardTitle.displayName = 'MiraCardTitle';

export const CardDescription = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnCardDescription
        ref={ref}
        className={cn(styles.miraCardDescription, className)}
        {...props}
      />
    );
  }
);

CardDescription.displayName = 'MiraCardDescription';

export const CardContent = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnCardContent
        ref={ref}
        className={cn(styles.miraCardContent, className)}
        {...props}
      />
    );
  }
);

CardContent.displayName = 'MiraCardContent';

export const CardFooter = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnCardFooter
        ref={ref}
        className={cn(styles.miraCardFooter, className)}
        {...props}
      />
    );
  }
);

CardFooter.displayName = 'MiraCardFooter';
